export default __webpack_public_path__ + "static/media/Schwein-im-Heu.63624f25.png";